"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var treeData = [{
  title: 'parent 1',
  key: '0-0',
  children: [{
    title: 'parent 1-0',
    key: '0-0-0',
    disabled: true,
    children: [{
      title: 'leaf',
      key: '0-0-0-0',
      disableCheckbox: true
    }, {
      title: 'leaf',
      key: '0-0-0-1'
    }]
  }, {
    title: 'parent 1-1',
    key: '0-0-1',
    children: [{
      title: /*#__PURE__*/_react.default.createElement("span", {
        style: {
          color: '#1890ff'
        }
      }, "sss"),
      key: '0-0-1-0'
    }]
  }]
}];
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(_antd.Tree, {
    checkable: true,
    defaultExpandedKeys: ['0-0-0', '0-0-1'],
    defaultSelectedKeys: ['0-0-0', '0-0-1'],
    defaultCheckedKeys: ['0-0-0', '0-0-1'],
    treeData: treeData
  });
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorPrimary', 'controlOutline', 'colorBgContainer'],
  key: 'default'
};
var _default = exports.default = componentDemo;